export const getInitials = (name: string) => {
  if (!name) return "";

  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    // If there's only one word, take the first two letters of the single word
    return parts[0].substring(0, 2).toUpperCase();
  }
  const [firstName, lastName] = parts;
  return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
};